import { ConfigItemData } from 'api-client';
import productsApi from 'api/api';
import Accordion from 'components/Accordion/Accordion';
import AccordionContent from 'components/Accordion/AccordionContent/AccordionContent';
import { FormColorSquareList } from 'components/ColorSquareList/FormColorSquareList';
import { FormRadioButtonList } from 'components/RadioButtonList/FormRadioButtonList';
import SectionComponent from 'components/SectionComponent/SectionComponent';
import { WindowCreatorFormState } from 'components/WindowCreator/RowFormPages';
import { FieldPath, useFormContext } from 'react-hook-form';
import { useIsMd } from 'utils/useIsMd';
import { hasBaseRowInfo, pickBaseRowInfo } from 'utils/useWindowFormContext';
import './ConfigurationDetailsComponent.scss';

const AccordionConfigComponent = ({
  data,
  name,
  hideIfOne,
}: {
  data?: ConfigItemData;
  name: FieldPath<WindowCreatorFormState>;
  hideIfOne?: boolean;
}) => {
  // Hide Accordion if we
  // 1. Have no data
  // 2. If we only have one option and have specified "hideIfOne"
  return data && !(hideIfOne && data.data.length <= 1) ? (
    <Accordion heading={data?.title}>
      <AccordionContent
        description={data?.description}
        popupInfo={data?.infoPopup?.body}
      >
        <FormRadioButtonList large name={name} radioOptions={data?.data} />
      </AccordionContent>
    </Accordion>
  ) : null;
};

export const ConfigurationDetailsComponent = () => {
  const { watch } = useFormContext<WindowCreatorFormState>();
  const [prospectRow] = watch(['prospectRow']);
  const { data: configData } = productsApi.endpoints.getConfigData.useQuery(
    pickBaseRowInfo(prospectRow),
    {
      skip: !hasBaseRowInfo(prospectRow),
    }
  );
  const isMd = useIsMd();
  if (!configData) return null;

  return (
    <SectionComponent
      title={'Konfigurationsdetaljer'}
      number={8}
      classNames="tw-mt-8 md:tw-mt-0 md:tw-h-full"
      hideNumber={isMd}
      hideDescription={isMd}
    >
      <div className="ConfigurationDetailsComponent">
        {configData.colors && (
          <Accordion heading={configData.colors.title}>
            {configData.colors.insideColors?.colorData?.length > 0 && (
              <AccordionContent
                title={configData.colors.insideColors?.title}
                description={configData.colors.insideColors?.description}
              >
                <FormColorSquareList
                  name="prospectRow.insideCoatingId"
                  colorOptions={configData.colors.insideColors?.colorData}
                />
              </AccordionContent>
            )}
            {configData.colors.outsideColors &&
              configData.colors.outsideColors?.colorData?.length > 0 && (
                <AccordionContent
                  title={configData.colors.outsideColors?.title}
                  description={configData.colors.outsideColors?.description}
                >
                  <FormColorSquareList
                    name="prospectRow.outsideCoatingId"
                    colorOptions={configData.colors.outsideColors.colorData}
                  />
                </AccordionContent>
              )}
          </Accordion>
        )}
        <AccordionConfigComponent
          data={configData.glass}
          name={'prospectRow.glassId'}
        />
        <AccordionConfigComponent
          data={configData.airVent}
          name={'prospectRow.airVentId'}
        />
        <AccordionConfigComponent
          data={configData.hanging}
          name={'prospectRow.hangingId'}
        />
        <AccordionConfigComponent
          data={configData.handle}
          name={'prospectRow.handleId'}
        />
        <AccordionConfigComponent
          data={configData.hinge}
          name={'prospectRow.hingeId'}
        />
        <AccordionConfigComponent
          hideIfOne={true}
          data={configData.alignment}
          name={'prospectRow.alignmentId'}
        />
        {/* {configData.sunscreen && (
        <Accordion
          heading={configData.sunscreen?.title}
          closeButtonLabel={`Lägg till ${configData.sunscreen.title}`}
        >
          <AccordionContent description={configData.sunscreen?.description}>
            <FormStockItemSelector
              name="prospectRow.sunscreen"
              stockItem={configData.sunscreen}
            />
          </AccordionContent>
        </Accordion>
      )}
      <AccordionConfigComponent
        data={configData.mosquitoNet}
        name={'prospectRow.mosquitoNetId'}
      /> */}
      </div>
    </SectionComponent>
  );
};

export default ConfigurationDetailsComponent;
